export default __webpack_public_path__ + "6354be05a2f901b7fce690e4a5f181f1.svg";